module.exports = __webpack_public_path__ + "AgnibhaGoswami-620961df.webp";